import { render, staticRenderFns } from "./universal_search.vue?vue&type=template&id=6f5f3dc8&scoped=true&"
import script from "./universal_search.vue?vue&type=script&lang=coffee&"
export * from "./universal_search.vue?vue&type=script&lang=coffee&"
import style0 from "./universal_search.vue?vue&type=style&index=0&id=6f5f3dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5f3dc8",
  null
  
)

export default component.exports